export const RecodeBase64SpecialChars = (b64EncodedWord) => {
    let replace = /&#x2B;/gi;
    let rta = b64EncodedWord.replace(replace, '+');
    return rta;
}